module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.account && Object.keys(_vm.account).length > 0) ? _c('shared-product-provide', {
    attrs: {
      "product": _vm.product,
      "fromModule": _vm.fromModule,
      "toModule": _vm.toModule,
      "account": {
        identifier: _vm.account.shopId
      }
    }
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loadingAttributes || _vm.loadingSizeCharts || _vm.loading
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "required": true,
      "label": _vm.$t('condition.label'),
      "columns": 3,
      "error": _vm.getError('condition', _vm.product.condition)
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.condition),
      expression: "product.condition"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.product, "condition", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.conditionOptions), function(condition) {
    return _c('option', {
      domProps: {
        "value": condition.value
      }
    }, [_vm._v(_vm._s(condition.label))])
  }), 0)]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Forma de envio",
      "columns": 3,
      "required": true,
      "error": _vm.getError('shippingOptionSelected', _vm.product.shippingMethods)
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.shippingOptions,
      "track-by": "logistics_channel_id",
      "label": "logistics_channel_name",
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": false,
      "hide-selected": true,
      "placeholder": "Selecione uma ou mais formas de envio"
    },
    model: {
      value: (_vm.shippingOptionSelected),
      callback: function($$v) {
        _vm.shippingOptionSelected = $$v
      },
      expression: "shippingOptionSelected"
    }
  })], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "required": true,
      "label": "Frete grátis",
      "columns": 3
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.shippingFree),
      expression: "product.shippingFree"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.product, "shippingFree", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.shippingFreeOptions), function(shippingFreeOption) {
    return _c('option', {
      domProps: {
        "value": shippingFreeOption
      }
    }, [_vm._v(_vm._s(_vm.$t((shippingFreeOption + ".label"))))])
  }), 0)]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Categoria de nivel 1",
      "columns": 3,
      "error": _vm.getError('category', _vm.product.productId),
      "required": true
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.categories,
      "selectLabel": "",
      "selectedLabel": "",
      "label": "name",
      "track-by": "name",
      "placeholder": "Escolha"
    },
    model: {
      value: (_vm.category),
      callback: function($$v) {
        _vm.category = $$v
      },
      expression: "category"
    }
  })], 1), _vm._v(" "), (_vm.category !== null && _vm.isCategoryFatherRequired === true) ? _c('form-group', {
    attrs: {
      "label": "Categoria de nivel 2",
      "columns": 3,
      "error": _vm.getError('categoryFather', _vm.product.productId),
      "required": _vm.isCategoryFatherRequired
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.category.children,
      "selectLabel": "",
      "selectedLabel": "",
      "placeholder": "Escolha",
      "label": "name",
      "track-by": "name"
    },
    model: {
      value: (_vm.categoryFather),
      callback: function($$v) {
        _vm.categoryFather = $$v
      },
      expression: "categoryFather"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.categoryFather !== null && _vm.categoryFather !== '' && _vm.category !== null && _vm.category !== '' && _vm.isCategoryChildrenRequired === true) ? _c('form-group', {
    attrs: {
      "label": "Categoria de nivel 3",
      "columns": 3,
      "error": _vm.getError('categoryChildren', _vm.product.productId),
      "required": _vm.isCategoryChildrenRequired
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.categoryFather.children,
      "selectLabel": "",
      "selectedLabel": "",
      "placeholder": "Escolha",
      "label": "name",
      "track-by": "name"
    },
    model: {
      value: (_vm.categoryChildren),
      callback: function($$v) {
        _vm.categoryChildren = $$v
      },
      expression: "categoryChildren"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.categoryChildren !== null && _vm.categoryChildren !== '' && _vm.categoryFather !== null && _vm.categoryFather !== '' && _vm.category !== null && _vm.category !== '' && _vm.isCategoryFourthRequired === true) ? _c('form-group', {
    attrs: {
      "label": "Categoria de nivel 4",
      "columns": 3,
      "error": _vm.getError('categoryFourth', _vm.product.productId),
      "required": _vm.isCategoryFourthRequired
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.categoryChildren.children,
      "selectLabel": "",
      "selectedLabel": "",
      "placeholder": "Escolha",
      "label": "name",
      "track-by": "name"
    },
    model: {
      value: (_vm.categoryFourth),
      callback: function($$v) {
        _vm.categoryFourth = $$v
      },
      expression: "categoryFourth"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.sizeCharts.length) ? [_c('div', {
    staticClass: "l-col-12@md"
  }, [_c('div', {
    staticClass: "divider"
  }, [_c('span', [_vm._v("Tabela de medidas")])])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Tabela de medidas",
      "columns": 3,
      "required": true,
      "error": _vm.getError('sizeChart', _vm.product.productId)
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedSizeChart),
      expression: "selectedSizeChart"
    }],
    staticClass: "form-select",
    attrs: {
      "disabled": _vm.disabledInputs()
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedSizeChart = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.$t('select.label')))]), _vm._v(" "), _vm._l((_vm.sizeCharts), function(sizeChart) {
    return _c('option', {
      key: sizeChart.id,
      domProps: {
        "value": sizeChart
      }
    }, [_vm._v(_vm._s(sizeChart.name))])
  })], 2)])] : _vm._e(), _vm._v(" "), (_vm.visibleAttributes.length) ? _c('div', {
    staticClass: "l-col-12@md"
  }, [_c('div', {
    staticClass: "divider"
  }, [_c('span', [_vm._v("Atributos")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.visibleAttributes), function(attribute) {
    return _c('form-group', {
      key: attribute.attribute_id,
      attrs: {
        "label": _vm.resolveName(attribute),
        "columns": 3,
        "error": _vm.getError(attribute.attribute_id, _vm.product.productId),
        "required": _vm.isAttributeRequired(attribute)
      }
    }, [(_vm.isSingleComboBox(attribute)) ? [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (attribute.value),
        expression: "attribute.value"
      }],
      staticClass: "form-input",
      attrs: {
        "type": "text",
        "list": _vm.attributeOptionsId(attribute),
        "disabled": _vm.disabledInputs()
      },
      domProps: {
        "value": (attribute.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(attribute, "value", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('datalist', {
      attrs: {
        "id": _vm.attributeOptionsId(attribute)
      }
    }, _vm._l((attribute.attribute_value_list), function(attributeValue) {
      return _c('option', {
        key: attributeValue.value_id,
        domProps: {
          "value": _vm.resolveName(attributeValue)
        }
      })
    }), 0)] : (attribute.attribute_value_list && [1, 4, 5].includes(attribute.attribute_info.input_type)) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (attribute.value),
        expression: "attribute.value"
      }],
      staticClass: "form-select",
      attrs: {
        "multiple": [4, 5].includes(attribute.attribute_info.input_type)
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(attribute, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.checkSelectionLimit(attribute, attribute.attribute_info.max_value_count !== undefined ? attribute.attribute_info.max_value_count : false)
        }]
      }
    }, [(attribute.attribute_info.input_type === 1) ? _c('option', {
      attrs: {
        "selected": ""
      },
      domProps: {
        "value": undefined
      }
    }, [_vm._v(_vm._s(_vm.$t('select.label')))]) : _vm._e(), _vm._v(" "), _vm._l((attribute.attribute_value_list), function(attributeValue) {
      return _c('option', {
        key: attributeValue.value_id,
        domProps: {
          "value": attributeValue.value_id
        }
      }, [_vm._v(_vm._s(_vm.resolveName(attributeValue)))])
    })], 2) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (attribute.value),
        expression: "attribute.value"
      }],
      staticClass: "form-input",
      attrs: {
        "type": "text",
        "disabled": _vm.disabledInputs(),
        "error": _vm.getError(attribute.value, _vm.product.productId)
      },
      domProps: {
        "value": (attribute.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(attribute, "value", $event.target.value)
        }
      }
    }), _vm._v(" "), (attribute.attribute_info.format_type == 2) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (attribute.value_unit),
        expression: "attribute.value_unit"
      }],
      staticClass: "form-select",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(attribute, "value_unit", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "selected": ""
      },
      domProps: {
        "value": undefined
      }
    }, [_vm._v(_vm._s(_vm.$t('select.label')))]), _vm._v(" "), _vm._l((attribute.attribute_info.attribute_unit_list), function(attributeValueUnit) {
      return _c('option', {
        key: attributeValueUnit,
        domProps: {
          "value": attributeValueUnit
        }
      }, [_vm._v(_vm._s(attributeValueUnit))])
    })], 2) : _vm._e()], 2)
  }), _vm._v(" "), (_vm.moduleConfigurations !== null && _vm.moduleConfigurations.taxInfo.useShopeeInvoice) ? _c('div', {
    staticClass: "l-col-12@md"
  }, [_c('div', {
    staticClass: "divider"
  }, [_c('span', [_vm._v("Atributos Fiscais ")])])]) : _vm._e(), _vm._v(" "), (_vm.moduleConfigurations !== null && _vm.moduleConfigurations.taxInfo.useShopeeInvoice) ? _c('form-group', {
    attrs: {
      "label": "NCM",
      "columns": 3,
      "error": _vm.getError('ncm', _vm.product.ncm),
      "required": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.ncm),
      expression: "product.ncm"
    }],
    staticClass: "form-input",
    attrs: {
      "disabled": _vm.disabledInputs()
    },
    domProps: {
      "value": (_vm.product.ncm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "ncm", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.moduleConfigurations !== null && _vm.moduleConfigurations.taxInfo.useShopeeInvoice) ? _c('form-group', {
    attrs: {
      "label": "CFOP - Código para o mesmo estado",
      "columns": 3,
      "error": _vm.getError('cfopSameState', _vm.product.cfopSameState),
      "required": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.cfopSameState),
      expression: "product.cfopSameState"
    }],
    staticClass: "form-input",
    attrs: {
      "disabled": _vm.disabledInputs()
    },
    domProps: {
      "value": (_vm.product.cfopSameState)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "cfopSameState", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.moduleConfigurations !== null && _vm.moduleConfigurations.taxInfo.useShopeeInvoice) ? _c('form-group', {
    attrs: {
      "label": "CFOP - Código para um estado diferente",
      "columns": 3,
      "error": _vm.getError('cfopDifferentState', _vm.product.cfopDifferentState),
      "required": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.cfopDifferentState),
      expression: "product.cfopDifferentState"
    }],
    staticClass: "form-input",
    attrs: {
      "disabled": _vm.disabledInputs()
    },
    domProps: {
      "value": (_vm.product.cfopDifferentState)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "cfopDifferentState", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.moduleConfigurations !== null && _vm.moduleConfigurations.taxInfo.useShopeeInvoice) ? _c('form-group', {
    attrs: {
      "label": "CSOSN",
      "columns": 3,
      "error": _vm.getError('csosn', _vm.product.csosn),
      "required": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.csosn),
      expression: "product.csosn"
    }],
    staticClass: "form-input",
    attrs: {
      "disabled": _vm.disabledInputs()
    },
    domProps: {
      "value": (_vm.product.csosn)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "csosn", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.moduleConfigurations !== null && _vm.moduleConfigurations.taxInfo.useShopeeInvoice) ? _c('form-group', {
    attrs: {
      "label": "Origem",
      "columns": 3,
      "error": _vm.getError('origin', _vm.product.origin),
      "required": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.origin),
      expression: "product.origin"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.product, "origin", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "domestic"
    }
  }, [_vm._v("Nacional")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "foreig"
    }
  }, [_vm._v("Importado")])])]) : _vm._e(), _vm._v(" "), (_vm.moduleConfigurations !== null && _vm.moduleConfigurations.taxInfo.useShopeeInvoice) ? _c('form-group', {
    attrs: {
      "label": "CEST",
      "columns": 3,
      "error": _vm.getError('cest', _vm.product.cest),
      "required": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.cest),
      expression: "product.cest"
    }],
    staticClass: "form-input",
    attrs: {
      "disabled": _vm.disabledInputs()
    },
    domProps: {
      "value": (_vm.product.cest)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "cest", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.moduleConfigurations !== null && _vm.moduleConfigurations.taxInfo.useShopeeInvoice) ? _c('form-group', {
    attrs: {
      "label": "Unidade de Medida",
      "columns": 3,
      "error": _vm.getError('measureUnit', _vm.product.measureUnit),
      "required": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.measureUnit),
      expression: "product.measureUnit"
    }],
    staticClass: "form-input",
    attrs: {
      "disabled": _vm.disabledInputs()
    },
    domProps: {
      "value": (_vm.product.measureUnit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "measureUnit", $event.target.value)
      }
    }
  })]) : _vm._e()], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b879164","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/shopee/provide/Product.vue
// module id = 3065
// module chunks = 0